module.exports = __webpack_public_path__ + "static/bg-3c03f8967bec3452c5cd4e40d5ca2ae1.png";